import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '@services/connection-service/index';
import { EventLoggerService } from '@services/event-logger-service';
import { AppConfig } from '../../app.config';

@Component({
  selector: 'isotretinoin-consent-form',
  templateUrl: './isotretinoin-consent-form.html',
  standalone: false,
})

export class IsotretinoinConsentForm implements OnInit {
    user: Table.User;
    userLanguage: string;
    consentPresent: boolean;
    constructor(
        public appConfig: AppConfig,
        public conn: ConnectionService,
        public eventLogger: EventLoggerService) {
    }

  async ngOnInit(): Promise<any> {
    this.user = this.conn.getActingUser();
    this.userLanguage = this.user.get('languagePreference');
    this.eventLogger.trackEvent('ISOTRETINOIN_CONSENT_FORM_OPEN', { userId: this.user.id });
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'isotretinoin-consent-form' }));
    this.consentPresent = await this.checkIfConsentIsGivenAlready();
  }

  async checkIfConsentIsGivenAlready(): Promise<boolean> {
    const userChatCache = await this.conn.findUserChatCache();
    const labels: string[] = userChatCache.get('label') || [];
  
    const hasConsentLabel =
      labels.includes(this.appConfig.Shared.ISOTRETINOIN_CONSENT.ISOTRETINOIN_CONSENT_GIVEN) ||
      labels.includes(this.appConfig.Shared.ISOTRETINOIN_CONSENT.ISOTRETINOIN_CONSENT_NOT_GIVEN);
  
    return hasConsentLabel;
  }
  

  async handleConsent(isConsentGiven: boolean): Promise<void> {
    await this.conn.recordIsotretinoinConsent(isConsentGiven);
    this.eventLogger.trackEvent('ISOTRETINOIN_CONSENT_GIVEN', { userId: this.user.id, isConsentGiven: isConsentGiven ? 'YES' : 'NO' });
    this.conn.navigateToURL('/user?tab=home', false, true);
}
}
